// @ts-check
/**
 * @fileOverview 통합검색엔진 랩퍼
 * @name api.js
 * @author im7696122
 * @license Daiso
 */

import './typedef'
import axios from 'axios'
import logger from '@/logger/console-log'

/**
 * 더보기 검색할 쿼리. 더보기 클릭 시 또는 추천셋 검색 시 해당 파라미터 사용.
 * @readonly
 * @enum {string}
 * @constant
 */
export const searchQueryType = {
  /** @type {string} @const '' : 통합검색(전체) */
  DEFAULT: '',
  /** @type {string} @const 상품검색 (더보기용) */
  Q1: 'Q1',
  /** @type {string} @const 오늘의 발견 검색 (더보기용) */
  Q2: 'Q2',
  /** @type {string} @const 이벤트 검색 (더보기용) */
  Q3: 'Q3',
  /** @type {string} @const 이번주(기획전) 검색 (더보기용) */
  Q4: 'Q4',
  /** @type {string} @const 인기상품리스트 ( 인기검색어 상품) */
  R1: 'R1',
  /** @type {string} @const
     - 1) 홈탭 - 메인홈 - 판매량 랭킹: 고객 반응 BEST
     - 2) 브랜드 모아보기 - 브랜드 모아보기 - 판매량 랭킹 : 고객반응' BEST */
  R2: 'R2',
  /** @type {string} @const 대카테고리별 리뷰 랭킹 : 고객 리뷰' 상품 */
  R3: 'R3',
  /** @type {string} @const 서브매장 - 정기배송 - 정기배송 많이 구매한 상품:정기배송 시작하기 */
  R4: 'R4',
  /** @type {string} @const 서브매장 - 정기배송 - 조회수 데이터 기반 상품 추천 : 알뜰하게' 쇼핑하기(워싱예정) */
  R5: 'R5',
  /** @type {string} @const 서브매장 - 정기배송 - 연령대별 자주 구매한 정기배송 상품 */
  R6: 'R6',
  /** @type {string} @const 서브매장 - 정기배송 - 최근 2주간 정기배송 판매량 랭킹 : 최근 구매가 많은' 인기상품 */
  R7: 'R7',
  /** @type {string} @const
     - 1) 상품카테고리 - 대카테고리매장 - 대카테고리 인기 판매 상품 추천 */
  R8: 'R8',
  /** @type {string} @const 상품카테고리 - 대카테고리매장 - 대카테고리 인기 상품 추천 (조회수 기반) */
  R9: 'R9',
  /** @type {string} @const 상품카테고리 - 대카테고리매장 - 대카테고리 정기배송 상품 추천 : $대카테고리명$에서 정기구매 */
  R10: 'R10',
  /** @type {string} @const 상품상세 - 상품상세 페이지 - (동일 소카테고리) 조회 수 높은 상품 추천 */
  R11: 'R11',
  /** @type {string} @const 상품상세 - 상품상세 페이지 - (동일 소카테고리) 인기 판매 상품 추천 : 알뜰하게 쇼핑하기(워싱가능) */
  R12: 'R12',
  /** @type {string} @const 브랜드 모아보기 - 전체 상품 노출 구좌 : 상품 더'보기 */
  R13: 'R13',
  /** @type {string} @const
     - 1) 장바구니 - 일반배송 장바구니 비어 있을 시 - 인기 판매 상품 추천 : 이런건 어때요?
     - 2)  장바구니 - 일반배송 장바구니 채워져있을 시 - 인기 판매 상품 추천 */
  R14: 'R14',
  /** @type {string} @const
     - 1) 장바구니 - 정기배송 꾸러미 비었을 시 - 정기배송 인기 판매 상품 추천
     - 2)  장바구니 - 정기배송 꾸러미 채워져 있을 시  - 정기배송 인기 판매 상품 추천 3)  서브매장 - 정기배송 홈 - 정기배송 많이 구매한 상품 */
  R15: 'R15',
  /** @type {string} @const
     - 1) 장바구니 - 매장픽업 장바구니 비어 있을 시 - 매장픽업인기 판매 상품 추천
     - 2)  장바구니 - 매장픽업 장바구니 채워져있을 시 - 인기 판매 상품 추천 */
  R16: 'R16',
  /** @type {string} @const
     - 1) 장바구니 - 대량배송 장바구니 비어 있을 시 - 대량배송 인기 판매 상품 추천
     - 2)  장바구니 - 대량배송 장바구니 채워져있을 시 - 인기 판매 상품 추천 */
  R17: 'R17',
  /** @type {string} @const 마이페이지_찜 목록이 비었을 시_인기 판매 상품추천 : 이런건 어때요? */
  R18: 'R18',
  /** @type {string} @const
     - 1) 랭킹 - 판매탭 - 인기 상품 추천 : $대카테고리명$ 인기 판매 1위
     - 2) 랭킹 - 리뷰탭 - 인기 상품 추천 : $대카테고리명$ 판매량 1위 */
  R21: 'R21',
  /** @type {string} @const 랭킹 - 실시간인기탭 - 조회수 높은 인기 상품, 가격대별/대카테고리별 인기상품 */
  R22: 'R22',
  /** @type {string} @const 랭킹 - 리뷰탭 - 온라인/대카테고리별/연령대별/가격대별 리뷰 랭킹 */
  R25: 'R25',
  R27: 'R27',
}

/**
 * 검색결과 정렬 유형
 * @readonly
 * @enum {string}
 * @const
 */
export const searchResultSortType = {
  /** @const @type {string} 추천 순 (default) */
  DEFAULT: '',
  /** @const @type {string} 낮은 가격 순 */
  lowPrc: 'lowPrc',
  /** @const @type {string} 높은 가격 순 */
  highPrc: 'highPrc',
  /** @const @type {string} 판매량 순 */
  order: 'order',
  /** @const @type {string} 리뷰 많은 순 */
  revw: 'revw',
  /** @const @type {string} 최신순 (상품수정일자 기준) */
  dtm: 'dtm',
  /** @const @type {string} 신상품 */
  newp: 'new',
  /** @const @type {string} 좋아요 많은 순 */
  like: 'like',
  /** @const @type {string} 조회수 많은 순 */
  inct: 'inct',
}

/**
 * 컨텐츠(오늘의 발견) 검색 정렬 유형
 * @readonly
 * @constant {enum}
 */
export const contentsSearchSortType = {
  /** @const @type {string} 공백 : 추천수 순 (default) */
  DEFAULT: '',
  /** @const @type {string} 조회수 높은 순 */
  inct: 'inct',
  /** @const @type {string} 스크랩(찜) 순 */
  zzim: 'zzim',
  /** @const @type {string} 좋아요 순 */
  like: 'like',
  /** @const @type {string} 최신순 (등록일자순) */
  dtm: 'dtm',
}

/**
 * 이벤트 검색 정렬 유형
 * @readonly
 * @enum {string}
 */
export const eventSearchSortType = {
  /** @const @type {string} 공백 : 추천수 순 (default) */
  DEFAULT: '',
  /** @const @type {string} 마감임박순 */
  ed: 'ed',
  /** @const @type {string} 최신순 (등록일자순) */
  dtm: 'dtm',
}

/**
 * 기획전 검색 정렬 유형
 * @readonly
 * @enum {string}
 */
export const exhibitionSearchSortType = {
  /** @const @type {string} 조회수 높은 순 */
  inct: 'inct',
  /** @const @type {string} 마감임박순 */
  ed: 'ed',
  /** @const @type {string} 기획전 시작일 순 */
  st: 'st',
}

/**
 * 통합검색 API
 * @async
 * @function search
 * @param {RequestParams} requestParams - 검색 파라미터
 * @returns {Promise<import('axios').AxiosResponse<SearchData>>}
 */
export async function search (requestParams) {
  const BASE_URL = process.env.API_SSN_BASE_URL2
  let PATH_SEARCH_TOTAL = 'SearchGoods'
  requestParams.isCategory = '1'
  try {
    /** @type {string} */
    const qs = Object.keys(requestParams)
      .map(key => `${key}=${encodeURIComponent(requestParams[key])}`)
      .join('&')
    console.log('qs >>>  ', requestParams.searchQuery)
    if (requestParams.searchQuery === 'R9') {
      PATH_SEARCH_TOTAL = 'GoodsCategoryLargeBest'
    } else if (requestParams.searchQuery === 'R11') {
      PATH_SEARCH_TOTAL = 'GoodsCategorySmall'
    } else if (requestParams.searchQuery === 'R12') {
      PATH_SEARCH_TOTAL = 'GoodsTogether'
    } else if (requestParams.searchQuery === 'R1') {
      PATH_SEARCH_TOTAL = 'GoodsTrend'
    } else if (requestParams.searchQuery === 'R27') {
      PATH_SEARCH_TOTAL = 'GoodsQuick'
    } else if (requestParams.searchQuery === 'R28') {
      PATH_SEARCH_TOTAL = 'GoodsPickup'
    }

    /** @type {import('axios').AxiosResponse<SearchData>} */
    const response = await /** @type import('axios').Axios */ axios.get(
      `${BASE_URL}/${PATH_SEARCH_TOTAL}?${qs}`
    )

    const { returnCode, status, version, resultSet, error } = response.data

    if (returnCode === 1) {
      logger.debug(`[Daiso Search] v${version} 정상`)
    } else if (returnCode === -60003) {
      logger.debug(error)
      throw new Error('검색엔진 연결 실패')
    } else if (returnCode === -60000) {
      logger.debug(error)
      throw new Error('네트워크 에러')
    } else if (returnCode === -60004) {
      logger.debug(error)
      throw new Error('검색 소요시간 타임아웃')
    } else if (returnCode === -70002) {
      logger.debug(error)
      throw new Error('Request 타임아웃')
    } else if (Number(returnCode) < 0) {
      logger.debug(error)
      throw new Error('검색 API 오류')
    }

    switch (status) {
      case 200:
        logger.debug('Success')
        break
      case 400:
        throw new Error('bad request')
      case 408:
        throw new Error('request timeout')
      case 500:
        throw new Error('internal server error')
    }

    const { errorCode } = resultSet
    if (errorCode) {
      logger.debug(errorCode)
    }

    return response
  } catch (err) {
    logger.log('Error >>', err)
  }
}
